import { c as classNames, U as FontAwesomeIcon, a8 as Link, aT as LinkButton, ai as createClassName } from './className-ac5eca03.js';
import { B as Badge, f as faChevronDownExports } from './Badge-5ccc1cba.js';
import React__default from 'react';

const HeaderButton = ({ icon, title, showText = false, showDropdownArrow = false, badgeVariant, badgeCount, badgeLabel, variant = 'default', href, onClick, children }) => {
    const classes = classNames(className(), {
        [className('mobile')]: variant === 'mobile'
    });
    const content = React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Badge, { variant: badgeVariant, count: badgeCount, ariaLabel: badgeLabel },
            React__default.createElement(FontAwesomeIcon, { icon: icon, size: variant === 'mobile' ? 'lg' : '2x' })),
        children,
        showText && variant !== 'mobile' && React__default.createElement("div", { className: className('text') }, title),
        showDropdownArrow && React__default.createElement(FontAwesomeIcon, { icon: faChevronDownExports.faChevronDown, size: "sm" }));
    if (href) {
        return React__default.createElement(Link, { className: classes, title: title, ariaLabel: title, href: href, onClick: onClick }, content);
    }
    else {
        return React__default.createElement(LinkButton, { className: classes, title: title, ariaLabel: title, onClick: onClick }, content);
    }
};
const className = createClassName('HeaderButton');

export { HeaderButton as H };
